<template>
  <div>
    <b-card>
      <b-tabs pills fill lazy>
        <b-tab :title="$t('clinic.doctors')">
          <!-- Search Patient Name -->
          <div>
            <b-row>
              <b-col cols="12" md="12">
                <h2>{{ $t("clinic.filter-doctors") }}</h2>
                <br />
              </b-col>

              <b-col md="4" cols="12">
                <b-form-group
                  :label="$t('clinic.doctors-name')"
                  label-for="Name"
                >
                  <b-form-input
                    id="Name"
                    v-model="doctorName"
                    :placeholder="$t('clinic.doctors-name')"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4" cols="12">
                <b-form-group :label="$t('common.type')" label-for="type">
                  <v-select
                    v-model="typeFilter"
                    :placeholder="$t('common.type')"
                    :options="[
                      { value: 'surgeon', label: this.$t('hospital.surgeon') },
                      {
                        value: 'anesthetist',
                        label: this.$t('hospital.anesthetist'),
                      },
                    ]"
                    :reduce="(item) => item.value"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4" cols="12">
                <b-form-group
                  :label="$t('clinic.doctors-phone')"
                  label-for="Phone"
                >
                  <VuePhoneNumberInput
                    v-model="doctorPhone"
                    @update="
                      (obj) => {
                        showPhoneObj(obj, 'countryCallingCode');
                      }
                    "
                    :placeholder="$t('clinic.doctors-phone')"
                    default-country-code="IQ"
                    :error="
                      doctorPhone ? isNotValid || doctorPhone[0] != 0 : false
                    "
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Search Button -->
            <b-row>
              <b-col cols="12" md="12">
                <br />
              </b-col>
              <b-col
                cols="12"
                md="12"
                class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
              >
                <b-button variant="primary" @click="getDoctorsList()">
                  {{ $t("common.search") }}
                  <b-icon-search class="ml-1"></b-icon-search>
                </b-button>
              </b-col>
            </b-row>
            <!-- Data Table  -->
            <div class="d-flex justify-content-between mt-4 mb-2">
              <h2>{{ $t("clinic.doctors") }}</h2>
            </div>

            <b-table
              :items="data"
              responsive
              :fields="tableColumns"
              primary-key="id"
              show-empty
              empty-text="No matching results found"
              class="position-relative"
              v-if="!loading"
            >
              <template #cell(name)="data">
                <div class="text-nowrap font-weight-bold" style="color: black">
                  {{ data.item.name }}
                  <span
                    v-if="data.item.type === 'surgeon'"
                    class="text-success"
                  >
                    ({{ $t("surgery.surgeon-doctor") }})
                  </span>
                  <span v-if="data.item.type === 'anesthetist'" class="text-success">
                    ({{ $t("surgery.anesthesia-doctor") }})
                  </span>
                </div>
              </template>
              <!-- Column: Actions -->
              <template #cell(surgeries)="data">
                <div class="d-flex flex-wrap">
                  <div
                    v-for="surgery in data.item.surgeries"
                    :key="surgery.title"
                    class="chips"
                  >
                    {{ surgery.title }} : {{ getType(surgery.type) }}
                  </div>
                </div>
              </template>
              <template #cell(actions)="data">
                <div class="text-nowrap d-flex">
                  <!-- @click="printId(data.item.id)" -->
                  <b-button
                    v-if="$store.state.app.permissions.includes('show-invoice')"
                    variant="primary"
                    class="mx-1 bgcolor"
                    @click="
                      $router.push({
                        name: 'doctor-preview',
                        params: { id: data.item.id },
                      })
                    "
                  >
                    {{ $t("common.preview") }}
                  </b-button>
                </div>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted">Showing 1 to 10 Doctors</span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  @click="getDoctorsList()"
                >
                  <b-pagination
                    v-model="page"
                    :total-rows="this.dataCount"
                    :per-page="take"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-tab>
        <b-tab :title="$t('accounting.doctor-assistants')">
          <DoctorAsissAcounting />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BTag,
  BTags,
  BTab,
  BTabs,
} from "bootstrap-vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import permissionChecker from "@/mixins/permissionChecker";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import DoctorAsissAcounting from "./DoctorAsissAcounting.vue";
import vSelect from "vue-select";
export default {
  mixins: [permissionChecker],

  components: {
    DeleteModal,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    ActionsButtons,
    BTag,
    BTags,
    BTab,
    BTabs,
    DoctorAsissAcounting,
    vSelect,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        name: "",
        phone: "",
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        name: "",
        phone: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        { key: "name", sortable: true, label: this.$t("common.name") },
        {
          key: "phone",
          sortable: true,
          label: this.$t("clinic.doctors-phone"),
        },
        {
          key: "surgeries",
          sortable: true,
          label: this.$t("accounting.doctors-surgeries"),
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      doctorPhone: "",
      typeFilter: "",
    };
  },
  mounted() {
    this.getDoctorsList();
  },
  methods: {
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    getType(number) {
      switch (number) {
        case 1:
          return "كبرى";
        case 2:
          return "صغرى";
        case 3:
          return "متوسطة";
        case 4:
          return "فوق الكبرى";
        case 5:
          return "خاصة";
        default:
          return "";
      }
    },
    async getDoctorsList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/doctor?page=${this.page}&take=${this.take}&sort=-id&include=surgeries,`;

      if (this.doctorName) {
        url += `&filter[name]=${this.doctorName}`;
      }
      if (this.doctorPhone) {
        url += `&filter[phone]=${this.doctorPhone}`;
      }
      if (this.typeFilter) {
        url += `&filter[type]=${this.typeFilter}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },
  },
};
</script>
<style scoped>
/* CSS */
.chips {
  padding: 10px 20px;
  border-radius: 10px;
  background-color: #485fc7;
  color: #fff;
  margin: 2px 5px;
  min-width: 20px;
}
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
